var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUnfoldMore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "expand_content_FILL0_wght300_GRAD0_opsz20",
    d: "M260-692v-4h.945v3.055H264V-692Zm7.055-4v-3.055H264V-700h4v4Z",
    transform: "translate(-260.001 699.999)",
    fill: "#3953fb"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnfoldMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UnfoldMore.60374913.svg";
export { ForwardRef as ReactComponent };